import Model from 'src/app/common/model';

export default class SrTopicsModel extends Model {
  name: string;
  description: string;
  created_name: string;
  updated_name: string;

  constructor() {
    super();
  }
}
